<template>
    <v-list-item class="flex align-center">
        <SoliStatusAvatar
            :event="event"
            :purchaseOption="purchaseOption"
            :size="size"
            margin="mr-9"
        ></SoliStatusAvatar>
        <v-list-item-content>
            <v-list-item-subtitle>{{ getPaymentStatus }}</v-list-item-subtitle>
            <div class="mb-0">
                {{
                    purchaseOption ? `${purchaseOption.name}` : `${event.type}`
                }}
            </div>
            <v-list-item-subtitle v-if="purchaseOption?.category == 'drop-ins'">
                {{ purchaseOption.passes }} remaining</v-list-item-subtitle
            >
        </v-list-item-content>
        <v-list-item-action
            v-if="$page.props.staffView && !this.purchaseOption.pastDue"
            ><v-btn @click="visitStore()" icon class="shadow-blue"
                ><v-icon color="primary">local_offer</v-icon></v-btn
            ></v-list-item-action
        >
        <v-list-item-action
            v-if="$page.props.staffView && this.purchaseOption.pastDue"
            ><v-btn @click="viewPastDueInvoice()" icon class="shadow-blue"
                ><v-icon color="primary">payments</v-icon></v-btn
            >
            <div
                class="caption mt-1"
                style="white-space: normal; transform: translateX(6px)"
            >
                Pay Now
            </div></v-list-item-action
        >
    </v-list-item>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    name: "SoliStatus",
    props: {
        event: {},
        purchaseOption: {},
        size: {
            type: [Number, String],
            default: null,
        },
    },
    methods: {
        visitStore() {
            let billingUser = this.event.paidForBy;
            this.$inertia.visit(
                route("store", { tab: "frequent", user: billingUser })
            );
        },
        viewPastDueInvoice() {
            this.$inertia.visit(
                route("invoice.pastDue", this.purchaseOption.user.id),
                {
                    data: {
                        subscription_id: this.purchaseOption.pastDue,
                    },
                }
            );
        },
    },
    computed: {
        getPaymentStatus() {
            // handle event in series
            let option = this.purchaseOption;
            if (!option) return null;

            if (option.pastDue) return "Past Due";

            if (option.ends_at) {
                if (option.ends_at > this.globalMoment(this.event.starts_at)) {
                    return option.subPaid ? "Paid" : "Unpaid";
                }
                return "Unpaid";
            }

            if (option.category == "memberships") {
                return option.subPaid ? "Paid" : "Unpaid";
            }

            return option.paid ? "Paid" : "Unpaid";
        },
    },
};
</script>
